import React from 'react'
import { Redirect, Link } from 'react-router-dom'
import MainRoutes from '../containers/MainRoutes'
import Spinner from '../components/Spinner'

class ManageAppUmScreen extends React.Component {

  async componentDidMount () {
    if( this.props.login.id ) {
      await this.props.getFishTypes()
      await this.props.getFishMarket()
      await this.props.getUserListWithType('fisherman')
    }
  }

  logout = () => this.props.logOut();

  render() {
    if( !this.props.login.id ) return <Redirect to="/" />
    
    const { fishTypes, fishMarket } = this.props.fish,
          { fisherman } = this.props.users.userListWithType
    if( !fishTypes || !fishMarket || !fisherman ) return <Spinner />

    return (
    <div className="container">
      <div className="row">
        <div className="col-md-3">
          <div className="list-group">
            <div className="list-group-item list-group-item-action disabled">Menu</div>
            <Link 
              className="list-group-item list-group-item-action small" 
              to={{
                pathname: '/manageapp/manage-restaurant',
                state: { userType: 'restaurant' }
              }}
              >Zarządzaj restauracjami</Link>
            <Link className="list-group-item list-group-item-action small" to="/manageapp/manage-article">Zarządzaj artykułami</Link>
            <Link className="list-group-item list-group-item-action small" to="/manageapp/manage-event">Zarządzaj Wydarzeniami</Link>
            <button className="list-group-item list-group-item-action small" onClick={this.logout}>Wyloguj</button>
          </div>
        </div>
        <div className="col-md-9">
          <MainRoutes {...this.props} />
        </div>
      </div>
    </div>
    )
  }

}






export default ManageAppUmScreen



// WEBPACK FOOTER //
// ./src/screens/ManageAppUmScreen.js